exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-btn[data-v-d4d018aa] {\n  margin-right: 16px;\n}\n", ""]);

// exports
